import React from "react";

// The HOURS block of a payslip: the hours behind each pay line, beside the pay line. The server builds
// it (backend services/payslip_hours.py) so the screen, the printout and the PDF cannot disagree.
// A zero is a real 0.00; a line the system never stored says so instead of showing 0.

const php = (n) => new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" }).format(Number(n || 0));
const hrs = (n) => Number(n || 0).toLocaleString("en-PH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const SOURCE_LABEL = {
  recorded: "Recorded when payroll was computed",
  derived: "Worked out from the saved attendance",
  not_recorded: "Not recorded for this period",
};

export default function PayslipHours({ block, className = "" }) {
  if (!block) return null;
  if (block.source === "not_applicable") {
    return (
      <div className={`rounded-md border border-border bg-secondary/40 p-3 text-xs ${className}`} data-testid="payslip-hours" data-source="not_applicable">
        {block.note}
      </div>
    );
  }
  const lines = block.lines || [];
  return (
    <div className={`min-w-0 ${className}`} data-testid="payslip-hours" data-source={block.source}>
      <div className="flex flex-wrap items-center justify-between gap-2 bg-slate-100 px-3 py-2">
        <span className="font-black">HOURS</span>
        <span className="text-xs font-semibold text-slate-600" data-testid="payslip-hours-source">{SOURCE_LABEL[block.source] || block.source}</span>
      </div>
      <div className="mt-1 text-sm">
        {lines.map((l) => (
          <div key={l.key} className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 border-b border-slate-100 py-2" data-testid={`hours-line-${l.key}`}>
            <span className="min-w-0 break-words">{l.label}</span>
            <span className="text-right font-bold tabular-nums" data-testid={`hours-value-${l.key}`}>
              {l.hours === null || l.hours === undefined
                ? <span className="font-normal italic text-slate-500">not recorded for this period</span>
                : hrs(l.hours)}
            </span>
            <span className="min-w-0 break-words text-xs text-slate-500">{l.pay_label}</span>
            <span className="text-right text-xs text-slate-600 tabular-nums">
              {l.pay === null || l.pay === undefined
                ? (l.key === "regular_holiday" || l.key === "special_holiday" ? "in Holiday Pay" : "not recorded")
                : php(l.pay)}
            </span>
          </div>
        ))}
        <div className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 py-2 font-bold" data-testid="hours-total">
          <span>Total hours worked (all kinds of day)</span>
          <span className="text-right tabular-nums" data-testid="hours-total-value">
            {block.total_worked_hours === null || block.total_worked_hours === undefined
              ? <span className="font-normal italic text-slate-500">not recorded for this period</span>
              : hrs(block.total_worked_hours)}
          </span>
          <span className="text-xs font-normal text-slate-500">Days worked {block.days_worked ?? "-"}</span>
          <span className="text-right text-xs font-normal text-slate-500">Hourly rate {php(block.hourly_rate)}</span>
        </div>
      </div>
      <p className="mt-1 text-xs text-slate-500" data-testid="payslip-hours-note">{block.note}</p>
    </div>
  );
}
